module.exports = __webpack_public_path__ + "img/road-arctic.8b59fcbf.webp";